import src from "IMAGE";
export default { src, width: 226, height: 64, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAR0lEQVR42h2LMQqAMBDA+v+fiFMV7HXoKZ7QDgrqIPiaaDsEkiFOZiNZph+F6l60EdTI+4krx9Wi84G4bExp/YfCEJX7efkAm4Ezvn3k0n8AAAAASUVORK5CYII="};
